import MAvatar from "./MAvatar.vue";
export default MAvatar;
